export default "__VITE_ASSET__DfbKMtJS__"